import React from 'react'
import {DataObjectId} from 'yougile-model'
import {Avatar} from '@components/common/base/avatar'
import {UserName} from '@components/common/base/user-name'

interface ReferencedUserProps {
  userId?: DataObjectId
  guestId?: DataObjectId
}

export const ReferencedUser = ({userId, guestId}: ReferencedUserProps) => (
  <span className="inline-flex gap-4">
    {(userId || guestId) && (
      <Avatar
        userId={userId}
        guestId={guestId}
        size={16}
        hideStatus
        hideOutline
        hideHint
        className="flex-none self-center"
      />
    )}
    <UserName
      className="flex-initial self-baseline font-semibold"
      context="override"
      userId={userId}
      guestId={guestId}
    />
  </span>
)
